/**
 * MSaaS and Job Listing Enums
 * These enums match the Python enums in libs/models/models/mixins/job_listing_mixin/constants.py
 */

/**
 * Enumeration for shift differential calculation types.
 * Matches Python: ShiftDifferentialType
 *
 * Values:
 * - INCR_HOURLY_RATE: Incremental dollar amount per hour added to base rate.
 * - MULTIPLIER: Factor multiplied against the base rate.
 * - RVU: Absolute RVU rate that replaces the base RVU rate for that shift type.
 * - HOURLY_RATE: Absolute hourly rate that replaces (not modifies) the base rate.
 */
export enum ShiftDifferentialType {
  INCR_HOURLY_RATE = 'INCR_HOURLY_RATE',
  MULTIPLIER = 'MULTIPLIER',
  RVU = 'RVU',
  HOURLY_RATE = 'HOURLY_RATE',
}

/**
 * Enumeration for call shift differential calculation types.
 * Matches Python: CallShiftDifferentialType
 *
 * Values:
 * - INCR_HOURLY_RATE: Incremental dollar amount added to base call rate.
 * - MULTIPLIER: Factor multiplied against the base call rate.
 * - RVU: Absolute RVU rate that replaces the base RVU rate for that call shift type.
 * - HOURLY_RATE: Absolute hourly rate that replaces the base rate for call shifts.
 */
export enum CallShiftDifferentialType {
  INCR_HOURLY_RATE = 'INCR_HOURLY_RATE',
  MULTIPLIER = 'MULTIPLIER',
  RVU = 'RVU',
  HOURLY_RATE = 'HOURLY_RATE',
}

/**
 * Enumeration for compensation types.
 * Matches Python: CompensationType
 */
export enum CompensationType {
  HOUR = 'HOUR',
  SHIFT = 'SHIFT',
  RVU = 'RVU',
}

/**
 * Enumeration for RVU period types.
 * Matches Python: RVUPeriod
 */
export enum RVUPeriod {
  HOUR = 'HOUR',
  SHIFT = 'SHIFT',
  YEAR = 'YEAR',
}
